import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import Client3D, { Client3DProps } from "../../lib/three";
import ClientFabric from "../../lib/fabric"
import http from '../../lib/http'
import * as apis from '../../lib/apis'
import Menu, { Action as MenuAction, MenuType } from './plugins/menu'
import Head, { Action as HeadAction } from './head'
import Info, { Action as InfoAction } from './info'
import Loading from "./plugins/loading";
import Plugins from './plugins'
import Context from './context'
import Cutpart, { Action as CutpartAction, Height as CutpartHeight } from './cutpart'
import { Button, Toast, Drag, FixedNav } from '@nutui/nutui-react';
import { Events } from '../home/plugins/action_title'
import Pattern, { Action as PatternAction, Height as PatternHeight } from './pattern'
import Text, { Action as TextAction, Height as TextHeight } from './text'
import Color, { Action as ColorAction, } from './color'
import ActionTitle, { Action as ActionTitleAction, } from './action_title'
import Graffiti, { Action as GraffitiAction, } from './graffiti'
import Fashion, { Action as FashionAction } from './plugins/fashion'
import HistoryPanel from './historyPanel';
import List from './list'
import * as THREE from 'three';
import { GUI } from 'lil-gui';
const fclients = new Map()

const threeclients = new Map()

var temp3DheightCache: any = {}
var needHideTitle = false

const Index = (props: any) => {
    const params: any = useParams()
    const [searchParams] = useSearchParams();
    const is_preview = searchParams.get("is_preview");
    const product_id = searchParams.get("product_id");
    const designId = params.id;
    const partternAc = useRef<PatternAction>()

    const [activeMenu, setActiveMenu] = useState<MenuType>()

    const infoAc = useRef<InfoAction>()
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const [detailData, setDetailData] = useState<any>({ materials: { cutparts: [] } })
    const [detailAllData, setDetailAllData] = useState<any>({})
    const [curCutpartCode, setCurCutpartCode] = useState("")
    const [curCanvasClient, setCurCanvasClient] = useState<any>()
    const [curThreeClient, setCurThreeClient] = useState<any>()
    const [fabricClient, setFabricClient] = useState<any>(null)
    const [threeClient, setThreeClient] = useState<Client3D>()
    const [controPosition, setControPosition] = useState<any>()
    const [editMode, setEditMode] = useState<any>()
    const [fabricW, setFabricW] = useState<number>()
    const [menuHeight, setMenuHeight] = useState<number>()
    const [curActivityObject, setCurActivityObject] = useState<any>()
    const [subMenuMode, onSubMenuMode] = useState<number>()
    const [showTitle, setShowTitle] = useState<boolean>(true)
    const [safeHeigth, setSafeHeigth] = useState<number>(-1)
    const [progress, setProgress] = useState<number>(0)
    const [objectModified, setObjectModified] = useState(0)
    const [previewMode, setPreViewMode] = useState<boolean>(false)
    const [visibleFixedNav, setVisibleFixedNav] = useState(false);
    const [curFabric, setCurFabric] = useState<any>({})
    const [action3D, setAction3D] = useState<any>({})
    const [ossClient, setOssClient] = useState({})
    const [curEvent, setCurEvent] = useState<Events>()
    const [notEmptyCodes, setInnerNotEmptyCodes] = useState<any[]>([])
    // 添加响应式状态
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);

    const tc = useContext(Context)
    const actionTitleAc = useRef<ActionTitleAction>(null)
    const textAc = useRef<TextAction>()
    const colorAc = useRef<ColorAction>()
    const cutpartAc = useRef<CutpartAction>()
    const graffitiAc = useRef<GraffitiAction>()
    const fashionAc = useRef<FashionAction>()
    // head组件
    const headAc = useRef<HeadAction>()

    const [textPaneKey, setTextPaneKey] = useState<number>(0)
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const safeHeightRef: any = useRef()
    const menuRef: React.MutableRefObject<MenuAction | undefined> = useRef()
    const threeClientRef: any = useRef()

    const categoryId = useRef(0);

    // 一个特殊的状态
    const [status, setStatus] = useState(false);
    // 预加载
    const [preloadTrigger, setPreloadTrigger] = useState(false);

    const [normalScaleX, setNormalScaleX] = useState(0.3);
    const [normalScaleY, setNormalScaleY] = useState(0.3);

    const updateNormalScale = (x: number, y: number) => {
        if (action3D?.object3Dchilds) {
            Object.values(action3D.object3Dchilds).forEach((mesh: any) => {
                if (mesh.material?.normalScale) {
                    mesh.material.normalScale.set(x, y);
                    mesh.material.needsUpdate = true;
                }
            });
        }
    };
    const [preloadedData, setPreloadedData] = useState({
        [MenuType.WENZI]: null as any,
        [MenuType.YANSHE]: null as any,
        [MenuType.SUCAI]: null as any,
    });
    const urlParams = new URLSearchParams(useLocation().search);
    const design_id = urlParams.get("design_id");
    const [loading, setLoading] = useState({
        [MenuType.WENZI]: false,
        [MenuType.YANSHE]: false,
        [MenuType.SUCAI]: false,
    });
    //同步当前选中的菜单值
    const activeMenuRef = useRef(activeMenu);
    const [gui, setGui] = useState<InstanceType<typeof GUI> | null>(null);
    const guiParamsRef = useRef({
        normalScaleX: 0.3,
        normalScaleY: 0.3,
        repeatX: 1,
        repeatY: 1,
        shininess: 1, // 高光强度默认值
        opacity: 1, // 透明度默认值
        wireframe: false, // 线框模式默认值

        // 新增光照参数
        ambientLightIntensity: 0.7,
        directionalLight1Intensity: 0,
        directionalLight2Intensity: 0,
        directionalLight1X: 0,
        directionalLight1Y: 0,
        directionalLight1Z: 0,
        directionalLight2X: 0,
        directionalLight2Y: 0,
        directionalLight2Z: 0,
    });
    useEffect(() => {
        if (action3D && !gui && !previewMode) {
            const newGui = new GUI({
                autoPlace: false // 重要：禁止自动放置
            });

            // 获取3D画布容器
            const canvasContainer = canvasRef.current?.parentElement;
            if (canvasContainer) {
                // 设置GUI位置在画布容器内
                newGui.domElement.style.position = 'absolute';
                newGui.domElement.style.top = '10px';
                newGui.domElement.style.right = '10px';
                newGui.domElement.style.zIndex = '1000';
                newGui.domElement.style.width = '400px';
                // 添加到画布容器 打开展示出gui控制器
                // canvasContainer.appendChild(newGui.domElement);
            }
            const params = guiParamsRef.current;
            const materialFolder = newGui.addFolder('材质属性');
            const lightFolder = newGui.addFolder('光照控制');

            // 环境光强度
            lightFolder.add(params, 'ambientLightIntensity', 0, 2, 0.1)
                .name('环境光强度')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.ambientLight) {
                        client.ambientLight.intensity = value;
                    }
                });

            // 定向光1控制
            const dirLight1Folder = lightFolder.addFolder('主光源1');
            dirLight1Folder.add(params, 'directionalLight1Intensity', 0, 2, 0.1)
                .name('强度')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_1) {
                        client.directionalLight_1.intensity = value;
                    }
                });
            dirLight1Folder.add(params, 'directionalLight1X', -5, 5, 0.1)
                .name('X位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_1) {
                        client.directionalLight_1.position.x = value;
                    }
                });
            dirLight1Folder.add(params, 'directionalLight1Y', -5, 5, 0.1)
                .name('Y位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_1) {
                        client.directionalLight_1.position.y = value;
                    }
                });
            dirLight1Folder.add(params, 'directionalLight1Z', -5, 5, 0.1)
                .name('Z位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_1) {
                        client.directionalLight_1.position.z = value;
                    }
                });

            // 定向光2控制
            const dirLight2Folder = lightFolder.addFolder('主光源2');
            dirLight2Folder.add(params, 'directionalLight2Intensity', 0, 2, 0.1)
                .name('强度')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_2) {
                        client.directionalLight_2.intensity = value;
                    }
                });
            dirLight2Folder.add(params, 'directionalLight2X', -5, 5, 0.1)
                .name('X位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_2) {
                        client.directionalLight_2.position.x = value;
                    }
                });
            dirLight2Folder.add(params, 'directionalLight2Y', -5, 5, 0.1)
                .name('Y位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_2) {
                        client.directionalLight_2.position.y = value;
                    }
                });
            dirLight2Folder.add(params, 'directionalLight2Z', -5, 5, 0.1)
                .name('Z位置')
                .onChange((value: any) => {
                    const client = threeClientRef.current;
                    if (client && client.directionalLight_2) {
                        client.directionalLight_2.position.z = value;
                    }
                });
            // 默认关闭
            lightFolder.close();
            dirLight1Folder.close();
            dirLight2Folder.close();
            // 线框模式
            materialFolder.add(params, 'wireframe').name('线框模式')
                .onChange((value: any) => {
                    updateMaterialProperty('wireframe', value);
                });
            materialFolder.open();
            // 法线缩放控制
            const normalFolder = newGui.addFolder('法线缩放');
            normalFolder.add(params, 'normalScaleX', -5, 5, 0.1)
                .name('法线X')
                .onChange((value: any) => {
                    setNormalScaleX(value);
                    updateNormalScale(value, params.normalScaleY);
                });
            normalFolder.add(params, 'normalScaleY', -5, 5, 0.1)
                .name('法线Y')
                .onChange((value: any) => {
                    setNormalScaleY(value);
                    updateNormalScale(params.normalScaleX, value);
                });
            normalFolder.open();
            normalFolder.open();

            setGui(newGui);
        }

        return () => {
            if (gui) {
                gui?.destroy();
                setGui(null);
            }
        };
    }, [action3D, previewMode, gui]);
    const updateMaterialProperty = (property: string, value: any) => {
        if (action3D?.object3Dchilds) {
            Object.values(action3D.object3Dchilds).forEach((mesh: any) => {
                if (mesh.material && mesh.material[property] !== undefined) {
                    mesh.material[property] = value;
                    mesh.material.needsUpdate = true;
                }
            });
        }
    };
    useEffect(() => {
        if (guiParamsRef.current) {
            guiParamsRef.current.normalScaleX = normalScaleX;
            guiParamsRef.current.normalScaleY = normalScaleY;
            guiParamsRef.current.repeatX = 1;
            guiParamsRef.current.repeatY = 1;
        }
    }, [normalScaleX, normalScaleY]);

    useEffect(() => {
        const preloadData = async () => {

            // 分别加载各个组件的数据

            const loadYansheData = async () => {
                setLoading(prev => ({ ...prev, [MenuType.YANSHE]: true }));
                try {
                    const data = await http.get(apis.DESIGNER_COLOR, {
                        params: {
                            page: 1,
                            limit: 80,
                        }
                    });
                    setPreloadedData(prev => ({ ...prev, [MenuType.YANSHE]: data }));
                } catch (error) {
                    console.error('加载颜色数据失败:', error);
                } finally {
                    setLoading(prev => ({ ...prev, [MenuType.YANSHE]: false }));
                }
            };


            const loadWenziData = async () => {
                setLoading(prev => ({ ...prev, [MenuType.WENZI]: true }));
                try {
                    const data = await http.get(apis.DESIGNER_FONT, {
                        params: {
                            page: 1,
                            limit: 45,
                        }
                    });
                    setPreloadedData(prev => ({ ...prev, [MenuType.WENZI]: data }));
                } catch (error) {
                    console.error('加载文字数据失败:', error);
                } finally {
                    setLoading(prev => ({ ...prev, [MenuType.WENZI]: false }));
                }
            };

            const loadSucaiData = async () => {
                setLoading(prev => ({ ...prev, [MenuType.SUCAI]: true }));
                try {
                    const [patternGroupsObj, patternListpatternObj] = await Promise.all([
                        http.get(apis.DESIGNER_PATTERN_CATEGORY, {
                            params: { page: 1, limit: 10 }
                        }),
                        http.get(apis.DESIGNER_PATTERN, { // 假设这是图案列表的API
                            params: {
                                page: 1,
                                limit: 80,
                                status: 1,
                                category_id: categoryId.current
                            }
                        })
                    ]);

                    const data = {
                        patternGroups: patternGroupsObj,
                        patternObj: patternListpatternObj,
                    };
                    setPreloadedData(prev => ({ ...prev, [MenuType.SUCAI]: data }));
                } catch (error) {
                    console.error('加载素材数据失败:', error);
                } finally {
                    setLoading(prev => ({ ...prev, [MenuType.SUCAI]: false }));
                }
            };

            // 并行执行所有加载
            Promise.all([loadYansheData(), loadSucaiData(), loadWenziData()]);
        };

        preloadData();
    }, []);
    useEffect(() => {
        if (is_preview === "1" && threeClient) {
            const initPreview = async () => {
                // 先强制设置一次实际尺寸
                const actualWidth = document.body.clientWidth;
                const actualHeight = document.body.clientHeight;
                await new Promise(resolve => setTimeout(resolve, 100));
                temp3DheightCache.height = document.body.clientHeight
                if (showTitle) {
                    needHideTitle = true
                    setShowTitle(false)
                }
                threeClient?.setCanvasSize(actualWidth, actualHeight)
                setPreViewMode(true);
            };
            setTimeout(() => {
                initPreview();
            }, 1000)
        }
    }, [is_preview, threeClient]);
    // 监听窗口大小变化
    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });

            if (threeClient) {
                threeClient.setCanvasSize(window.innerWidth - calculateActualLeftWidth(), get3DinitHeight());
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [threeClient]);
    useEffect(() => {
        activeMenuRef.current = activeMenu;
    }, [activeMenu]);
    // 响应式布局计算
    const getResponsiveLayout = () => {
        const { width } = windowSize;

        if (width < 768) {
            return {
                operationWidth: '100%',
                cutpartWidth: '100%',
                displayFlexDirection: 'column' as const,
                showSidebars: false
            };
        } else if (width < 1024) {
            return {
                operationWidth: '40%',
                cutpartWidth: '40%',
                displayFlexDirection: 'row' as const,
                showSidebars: true
            };
        } else if (width < 1440) {
            return {
                operationWidth: '30%',
                cutpartWidth: '30%',
                displayFlexDirection: 'row' as const,
                showSidebars: true
            };
        } else {
            return {
                operationWidth: '30%',
                cutpartWidth: '30%',
                displayFlexDirection: 'row' as const,
                showSidebars: true
            };
        }
    };

    const responsiveLayout = useMemo(() => getResponsiveLayout(), [windowSize.width]);

    useEffect(() => {
        curCanvasClient?.discardActiveObject()
        threeclients.get(curCutpartCode)?.activate()
    }, [curCutpartCode, curCanvasClient])

    // 监听画布操作
    useEffect(() => {

        if (!curCanvasClient) return;

        const canvas = curCanvasClient.getFabricCanvas();

        const handleChange = () => {
            const allObjects = canvas.getObjects();
            const validObjects = allObjects?.filter((obj: any) => {
                if (obj.type === 'text') {
                    return obj.text && obj.text.trim() !== '';
                }
                return true;
            });
            const hasContent = validObjects && validObjects.length > 0;
            setHasUnsavedChanges(hasContent);
        };

        canvas.on('object:added', handleChange);
        canvas.on('object:removed', handleChange);
        canvas.on('object:modified', handleChange);

        handleChange();

        return () => {
            canvas.off('object:added', handleChange);
            canvas.off('object:removed', handleChange);
            canvas.off('object:modified', handleChange);
        };
    }, [curCanvasClient]);

    const titleChange = async (code: string, d = detailData) => {
        try {
            // Toast.loading("加载中...")
            const fclient = fclients.get(code)
            if (!fclient) return
            const tclient = threeclients.get(code)
            if (!tclient) return
            let f = d?.model_materials?.cutparts?.find((i: any) => i.code === code)
            setCurCutpartCode(code)
            setCurCanvasClient(fclient)
            setCurThreeClient(tclient)
            setActiveMenu(MenuType.YANSHE);
            setTimeout(() => {
                if (colorAc?.current?.setShow) {
                    // colorAc.current.setShow(true);
                    showPlugin(MenuType.YANSHE);
                } else {
                }
            }, 0);
            if (f?.camera) {
                threeClientRef?.current?.setCamera(f.camera.x, f.camera.y, f.camera.z)
            }

            return true
        } catch (error) {
            console.error('加载颜色失败:', error)
        }
    }

    const onEditMode = (mode: string) => {
        setEditMode(mode)
    }

    const markAsChanged = () => {
        setHasUnsavedChanges(true);
    };

    const preview3D = () => {
        temp3DheightCache.height = threeClient?.getCanvasDom()?.clientHeight
        if (showTitle) {
            needHideTitle = true
            setShowTitle(false)
        }
        threeClient?.setCanvasSize(document.body.clientWidth, document.body.clientHeight)
        setPreViewMode(true)
    }

    const quitPreview3D = () => {

        if (needHideTitle) {
            setShowTitle(true)
        }
        if (threeClient) {
            setTimeout(() => {
                const leftTotalWidth = calculateActualLeftWidth();
                const newWidth = window.innerWidth - leftTotalWidth;
                threeClient?.setCanvasSize(newWidth, get3DinitHeight());
            }, 100);
        }
        needHideTitle = false
        setPreViewMode(false)
    }

    const fixedNavOnChange = (e: any) => {

        setVisibleFixedNav(e)
    }

    const choiceFabric = async (v: any, a: any, b: any) => {
        if (v.color === curFabric.color) {
            return
        }
        try {
            let cli: any
            if (a) {
                cli = a
            } else {
                cli = action3D
            }
            if (v.codes_info && v.codes_info.length !== 0) {
                for (let i = 0; i < v.codes_info.length; i++) {
                    let item = v.codes_info[i]
                    if (item.maps) {
                        cli.clearMap(item.code)
                    }
                }
            }
            if (v.codes_info && v.codes_info.length !== 0) {
                for (let i = 0; i < v.codes_info.length; i++) {
                    let item = v.codes_info[i]
                    if (item.maps) {
                        for (let j = 0; j < item.maps.length; j++) {

                            let jitem = item.maps[j]

                            // await cli.setMap(jitem.url, jitem.map, item.code)
                            await cli.openRepeat(item.code, true)
                            await cli.setMapOffset(item.code, -0.5, -0.5)
                            await cli.setMapRepeat(item.code, 3, 3)
                        }
                    }
                }
            }
            setCurFabric(v)
        } catch (error) {
            Toast.fail(t("底色加载失败"))
        }
    }

    const sleep = (time: any) => {
        return new Promise((resolve: any, reject) => {
            setTimeout(() => {
                resolve()
            }, time)
        })
    }

    const getCanvasDom = async (code: string): Promise<HTMLElement | null> => {
        let c = document.getElementById(code)
        if (!c) {
            await sleep(100)
            return await getCanvasDom(code)
        }
        return c
    }

    const calculateActualLeftWidth = () => {
        try {
            if (!responsiveLayout.showSidebars) {
                return 0;
            }

            const menuElement = document.querySelector('[data-component="menu"]');
            const operationElement = document.querySelector('[data-component="operation"]');
            const cutpartElement = document.querySelector('[data-component="cutpart"]');
            let totalWidth = 0;

            if (menuElement) {
                totalWidth += menuElement.getBoundingClientRect().width;
            } else {
                totalWidth += windowSize.width < 1024 ? 80 : 100;
            }

            if (operationElement) {
                totalWidth += operationElement.getBoundingClientRect().width;
            } else {
                totalWidth += windowSize.width < 1024 ? 300 : 500;
            }

            const currentMenu = activeMenuRef.current;
            if (currentMenu === MenuType.SUCAI || currentMenu === MenuType.WENZI) {
                if (cutpartElement) {
                    totalWidth += cutpartElement.getBoundingClientRect().width;
                } else {
                    totalWidth += windowSize.width < 1024 ? 400 : 600;
                }
            }
            return totalWidth;
        } catch (error) {
            console.error('计算左侧宽度失败，使用默认值');
            return windowSize.width < 768 ? 0 : 1300;
        }
    };

    useEffect(() => {
        if (status) {
            setControPosition(null)
            setHasUnsavedChanges(false);
            Toast.hide()
        }
    }, [status])
    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiPath = apis.DATA_DETAIL;
                const params = {
                    ...(product_id && { product_id }),
                    ...(design_id && { design_id }) //设计模块
                };

                const data = await http.get(`${apiPath}/${designId}`, { params });

                await initializeDesign(data);

            } catch (error) {
                console.error(error);
                Toast.fail("加载失败，请重试");
            }
        };
        fetchData();

    }, [designId, product_id, design_id]);

    const initializeDesign = async (data: any) => {
        if (!data) return;
        try {
            // 彻底清理之前的画布和状态
            if (threeClientRef.current) {
                threeClientRef.current.destroy();
                threeClientRef.current = null;
            }

            // 清理所有 fabric 画布
            fclients.forEach((client, key) => {
                try {
                    const canvas = client.getFabricCanvas();
                    canvas.dispose(); // 彻底销毁 fabric 画布
                } catch (error) {
                    console.warn(`清理画布 ${key} 时出错:`, error);
                }
            });

            // 清空所有缓存
            fclients.clear();
            threeclients.clear();

            // 重置相关状态
            setThreeClient(undefined);
            setFabricClient(null);
            setAction3D(null);
            setCurActivityObject(null);
            let ops: Client3DProps = {
                canvasDom: canvasRef?.current as HTMLCanvasElement,
                canvasWidth: document.body.clientWidth - calculateActualLeftWidth(),
                canvasHeight: windowSize.height - 15
            }
            let client: Client3D = new Client3D(ops);
            setThreeClient(client);
            threeClientRef.current = client;
            client.start();

            const fabricClient = new ClientFabric();
            setFabricClient(fabricClient);
            fabricClient?.cacheAllData()
            // 处理数据格式
            data.model_materials = JSON.parse(data.model_materials);
            let materialsData = data;

            window.document.title = data.model_name;
            setDetailData(materialsData);
            setDetailAllData(data);



            // 加载3D模型
            let modelData = materialsData?.model_materials;
            const action3D: any = await client.loadModel(modelData.obj_url, (p: number) => {
                setProgress(p);
            });

            setAction3D(action3D);
            Object.keys(action3D.object3Dchilds).forEach((meshName, index) => {
                const mesh = action3D.object3Dchilds[meshName];
                if (mesh.material && mesh.material.type === 'MeshPhongMaterial') {
                    // 动态查找对应mesh的法线贴图
                    let normalMapUrl = null;
                    if (modelData?.map_info) {
                        for (const mapInfo of modelData.map_info) {
                            const codeInfo = mapInfo.codes_info?.find((code: any) => code.code === meshName);
                            if (codeInfo) {
                                const normalMap = codeInfo.maps?.find((map: any) => map.map === 'normalMap');
                                if (normalMap) {
                                    normalMapUrl = normalMap.url;
                                    break;
                                }
                            }
                        }
                    }
                    // 只在没有法线贴图时创建新材质
                    if (normalMapUrl && !mesh.material.normalMap) {
                        const newMaterial = new THREE.MeshPhongMaterial({
                            normalMap: new THREE.TextureLoader().load(normalMapUrl),
                            normalScale: new THREE.Vector2(0.3, 0.3),
                            color: mesh.material.color,
                            side: THREE.DoubleSide,
                        });
                        mesh.material = newMaterial;
                    }

                }

            });
            // 初始化所有fabric画布
            let materialData = modelData?.cutparts
            for (let i = 0; i < materialData.length; i++) {
                let item = materialData[i];
                const fclient = fabricClient.loadCanvas(item.code);

                fclients.set(item.code, fclient);
                const cdom: any = await getCanvasDom(item.code);

                const tclient = action3D?.setMapCanvasTextureByName(item.code, cdom as HTMLCanvasElement);
                threeclients.set(item.code, tclient);

                // 回显文字照片背景处理
                if (materialsData?.designer_config_url) {
                    loadSavedTextToCanvas(fclient, item.code, materialsData);
                }

                fclient?.onCanvas((e: any, controPosition: any, event: string) => {
                    if (event === "after:render") {
                        const acObj = fclient.getFabricCanvas().getActiveObject();
                        if (acObj) {
                            setCurActivityObject(acObj);
                        } else {
                            setCurActivityObject(null);
                        }
                        tclient.needsUpdate();
                        setControPosition(controPosition);

                    }
                    if (event === "object:modified") {
                        setObjectModified(new Date().getTime());

                    }
                });

                // 数据加载完成后，延迟清空控制状态
                setTimeout(() => {
                    setCurActivityObject(null);
                    // 初始化加载数据的时候不展示控制按钮
                    setControPosition(null);
                }, 300);
            }
            // 设置UI相关
            const menuHeight = menuRef.current?.getHeight!() as number;
            setMenuHeight(menuHeight);
            const goldenRatio = document.body.clientHeight * 0.5;

            const w = document.body.clientHeight - goldenRatio - CutpartHeight - safeHeightRef.current.clientHeight - 80
            fabricClient.setWidth(w);
            setFabricW(w);
            setSafeHeigth(safeHeightRef.current.clientHeight);
            client.setCanvasSize(window.innerWidth - calculateActualLeftWidth(), window.innerHeight - 15);
            // 设置面料和标题
            if (modelData?.map_info && modelData?.map_info?.length !== 0) {
                choiceFabric(modelData?.map_info[0], action3D, fabricClient);
                const textureLoader = new THREE.TextureLoader();
                const normalTexture = await new Promise<THREE.Texture>((resolve) => {
                    textureLoader.load(modelData.map_info[0].codes_info[0].maps[0].url, resolve);
                })
                // 遍历 action3D.object3Dchilds 中的每个子对象
                Object.keys(action3D.object3Dchilds).forEach((meshName, index) => {
                    if (action3D.object3Dchilds[meshName].material) {
                        // 复制 result1 中的材质到 result2 中
                        if (modelData.map_info[0].codes_info[index].code === meshName) {
                            action3D.object3Dchilds[meshName].material.normalMap = normalTexture;
                            action3D.object3Dchilds[meshName].material.normalScale.set(0.3, 0.3);
                            action3D.object3Dchilds[meshName].material.needsUpdate = true
                            // 调整vector2
                            action3D.object3Dchilds[meshName].material.normalMap.repeat.set(1, 1);
                        }
                    }
                });
            }

            if (modelData.cutparts && modelData.cutparts.length !== 0) {
                titleChange(modelData.cutparts[0].code, data);
            }

        } catch (error) {
            console.error("初始化设计失败:", error);
            // Toast.hide();
            Toast.fail("加载失败");
        }
    };

    const loadSavedTextToCanvas = async (canvasClient: any, cutpartCode: string, materialsData: any) => {
        if (!materialsData?.designer_config_url) return;
        const response = await fetch(materialsData?.designer_config_url);
        const jsonData = await response.json();
        try {
            const canvas = canvasClient.getFabricCanvas();
            const savedCanvasData = jsonData.canvas_data?.find((v: any) => v.code === cutpartCode);
            if (savedCanvasData?.data) {
                await canvasClient.loadDataFromJson(savedCanvasData.data);
                canvas.clear();
                canvas.set('backgroundColor', savedCanvasData?.data?.background);
                canvas.renderAll();
                // 3D颜色加载
                const match = savedCanvasData?.data?.background?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
                if (match) {
                    const r = parseInt(match?.[1]);
                    const g = parseInt(match?.[2]);
                    const b = parseInt(match?.[3]);
                    // 将RGB转换为十六进制
                    const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
                    (threeClientRef.current as any)?.scene?.traverse((child: any) => {
                        if (child.isMesh && child.material) {
                            if (child?.material) {
                                if (child?.material?.name === cutpartCode) {
                                    // 材质名称匹配
                                    child.material.color = new THREE.Color(hex);
                                } else if (child?.material?.name === "" && child?.name === cutpartCode) {
                                    // 网格名称匹配
                                    child.material.color = new THREE.Color(hex);
                                }
                            }
                        }
                    });
                }

                // 分别处理文字和图片
                const objects = savedCanvasData.data.objects || [];
                const textObjects = objects.filter((obj: any) => obj.type === 'text');
                const imageObjects = objects.filter((obj: any) => obj.type === 'image');
                const pathObjects = objects.filter((obj: any) => obj.type === 'path');

                // 加载照片
                const imagePromises = imageObjects.map(async (imageData: any) => {

                    try {
                        const imageObject = await canvasClient.addImageById(imageData.src, 580 * 0.5);
                        if (imageObject) {
                            return new Promise(async (resolve) => {
                                if (imageObject.isNotLoaded !== undefined && imageObject.isNotLoaded) {
                                    imageObject.on('loaded', async () => {
                                        // 修改图片属性
                                        applyImageProperties(imageObject, imageData, canvas);
                                        resolve(true);
                                    });
                                } else {
                                    // 修改图片属性
                                    applyImageProperties(imageObject, imageData, canvas);
                                    resolve(true);
                                }
                            });
                        }
                    } catch (error) {
                        console.error(`加载图片失败:`, error);
                        return Promise.resolve(false);
                    }
                });
                await Promise.all(imagePromises);
                // 加载文字
                textObjects.forEach((textData: any) => {
                    const textObject = canvasClient.addText(textData.text);
                    if (textObject) {
                        textObject.left = textData.left;
                        textObject.top = textData.top;
                        textObject.fontSize = textData.fontSize;
                        textObject.fontFamily = textData.fontFamily;
                        textObject.fill = textData.fill;
                        textObject.fontWeight = textData.fontWeight;
                        textObject.fontStyle = textData.fontStyle;
                        textObject.opacity = textData.opacity;
                        textObject.angle = textData.angle;
                        textObject.scaleX = textData.scaleX;
                        textObject.scaleY = textData.scaleY;
                        canvas.renderAll();

                    }
                });
                // 加载涂鸦 - 手动创建 fabric.Path
                const fabricInstance = (window as any).fabric;
                pathObjects.forEach((pathData: any) => {
                    try {
                        const path = new fabricInstance.Path(pathData.path, {
                            fill: pathData.fill || 'transparent',
                            stroke: pathData.stroke || '#000000',
                            strokeWidth: pathData.strokeWidth || 2,
                            strokeLineCap: pathData.strokeLineCap || 'round',
                            strokeLineJoin: pathData.strokeLineJoin || 'round',
                            opacity: pathData.opacity || 1,
                            selectable: true,
                            evented: true,
                        });

                        // 设置位置和变换属性
                        path.set({
                            left: pathData.left,
                            top: pathData.top,
                            scaleX: pathData.scaleX,
                            scaleY: pathData.scaleY,
                            angle: pathData.angle,
                            originX: pathData.originX || 'left',
                            originY: pathData.originY || 'top',
                        });

                        // 设置坐标
                        if (typeof path.setCoords === 'function') {
                            path.setCoords();
                        }

                        canvas.add(path);

                    } catch (error) {
                        console.error('涂鸦回显失败:', error, pathData);
                    }
                });

                canvas.renderAll();
                checkNotEmptyCodes()
            }
        } catch (error) {
            console.error(`加载对象到画布 ${cutpartCode} 失败:`, error);
        }
    };

    const applyImageProperties = (imageObject: any, imageData: any, canvas: any) => {
        // 使用combine 添加正片叠底
        imageObject.left = imageData.left || 10;
        imageObject.top = imageData.top || 10;
        imageObject.scaleX = imageData.scaleX || 1;
        imageObject.scaleY = imageData.scaleY || 1;
        imageObject.angle = imageData.angle || 0;
        imageObject.opacity = imageData.opacity || 1;
        imageObject.originX = imageData.originX || 'left';
        imageObject.originY = imageData.originY || 'top';

        if (typeof imageObject.setCoords === 'function') {
            imageObject.setCoords();
        }
        setControPosition(null)
        setStatus(true)
    };
    const doOrder = () => {
        infoAc.current?.setShowPrice!(true)
        infoAc.current?.setShowSubmitOrder!(true)
    }

    const showPlugin = (key: MenuType) => {
        var safeHeight
        var fabricWs

        if (!responsiveLayout.showSidebars) {
            threeClient?.setCanvasSize(windowSize.width, windowSize.height);
            return;
        }
        // setActiveMenu(key);
        activeMenuRef.current = key;
        onEditMode(key.toString())

        switch (key) {
            case MenuType.YANSHE:
                setTimeout(() => {
                    setShowTitle(false)
                    fabricClient?.cacheAllData()
                    threeClient?.setCanvasSize(windowSize.width - calculateActualLeftWidth(), get3DinitHeight())
                    actionTitleAc.current?.registEvent!(Events.CONFIRM_COLOR as any)
                }, 150)
                return
            case MenuType.WENZI:
                setTimeout(() => {
                    if (actionTitleAc.current) {
                        setShowTitle!(false)
                        safeHeight = safeHeigth as number
                        actionTitleAc.current?.setBottom!(safeHeight + TextHeight)
                        threeClient?.setCanvasSize(windowSize.width - calculateActualLeftWidth(), get3DinitHeight())
                        actionTitleAc.current.registEvent!(Events.CONFIRM_TEXT as any)
                    } else {
                        console.warn("actionTitleAc.current 仍然为 null")
                    }

                    if (textAc.current) {
                        // textAc.current.setShow!(true)
                    } else {
                        console.warn("textAc.current 仍然为 null")
                    }

                    setShowTitle(false)
                    fabricClient?.cacheAllData()
                }, 150)
                return

            case MenuType.SUCAI:
                actionTitleAc.current?.setShow!(true)
                actionTitleAc.current?.registEvent!(Events.EDIT_PATTERN as any)
                setShowTitle!(false)
                fabricClient?.cacheAllData()
                fabricWs = fabricW as unknown as number
                safeHeight = safeHeigth as number

                threeClient?.setCanvasSize(windowSize.width - calculateActualLeftWidth(), get3DinitHeight())
                actionTitleAc.current?.setBottom!(PatternHeight + fabricWs + safeHeight)
                cutpartAc.current?.setBottom!(0)
                cutpartAc.current?.setUseSafeHeight!(true)
                return
        }
    }

    const get3DinitHeight = () => {
        return windowSize.height - 15
    }

    const onSubComplete = (em: Events) => {
        if (!hasUnsavedChanges) {
            Toast.fail(t("没有新的更改，忽略完成操作"));
            return;
        }
        switch (em) {
            case Events.EDIT_PATTERN:
            case Events.CONFIRM_TEXT:
                const allObjects = curCanvasClient?.getFabricCanvas().getObjects();
                const validObjects = allObjects?.filter((obj: any) => {
                    if (obj.type === 'text') {
                        return obj.text && obj.text.trim() !== '';
                    }
                    return true;
                });
                const hasAnyContent = validObjects && validObjects.length > 0;
                let isValid = false;
                let errorMessage = "";

                if (em === Events.CONFIRM_TEXT) {
                    const textResult = textAc.current?.confirm!()
                    isValid = textResult || hasAnyContent;
                    errorMessage = t("请输入文字或进行涂鸦");
                } else {
                    const activeObject = curCanvasClient?.getFabricCanvas().getActiveObject();
                    isValid = !!activeObject || hasAnyContent;
                    errorMessage = t("请先选择素材或进行涂鸦");
                }

                if (!isValid) {
                    Toast.fail(errorMessage);
                    return;
                }

                fabricClient?.cacheAllData()
                cutpartAc.current?.setShow!(false)
                actionTitleAc.current?.setShow!(false)
                threeClient?.setCanvasSize(windowSize.width - calculateActualLeftWidth(), get3DinitHeight())
                curCanvasClient?.discardActiveObject()
                setShowTitle!(true)
                addStep()
                break
            case Events.CONFIRM_COLOR:
                fabricClient?.cacheAllData()
                cutpartAc.current?.setShow!(false)
                actionTitleAc.current?.setShow!(false)
                threeClient?.setCanvasSize(windowSize.width - calculateActualLeftWidth(), get3DinitHeight())
                curCanvasClient?.discardActiveObject()
                setShowTitle!(true)
                addStep()
                break
            case Events.CONFIRM_FASHION:
                actionTitleAc.current?.registEvent!(Events.NONE as any)
                fashionAc.current?.confirm!()
                return
        }
        setHasUnsavedChanges(false);
        checkNotEmptyCodes()
    }

    const onDelCutpartObject = () => {
        const obj = curCanvasClient?.getFabricCanvas().getActiveObject()
        if (obj) {
            curCanvasClient?.getFabricCanvas().remove(obj)
            curCanvasClient?.getFabricCanvas().renderAll()
            markAsChanged?.();
        }
    }

    const onEditText = () => {
        cutpartAc.current?.setShow!(false)
        actionTitleAc.current?.setShow!(true)
        actionTitleAc.current?.setTitle!("文字")
        tc?.fabricClient?.cacheAllData()
        textAc.current?.editShow!()
        actionTitleAc.current?.registEvent!(Events.CONFIRM_TEXT as any)
    }

    const addStep = (j = null) => {
        headAc.current?.addStep!(j)
    }

    const checkNotEmptyCodes = () => {
        setInnerNotEmptyCodes(fabricClient?.isEmptyAll());

    }
    const contextValue = {
        showPlugin,
        detailData,
        detailAllData,
        curCanvasClient,
        curThreeClient,
        controPosition,
        editMode,
        onEditMode,
        fabricW,
        curCutpartCode,
        fabricClient,
        threeClient,
        menuHeight,
        curActivityObject,
        onSubMenuMode,
        subMenuMode,
        showTitle,
        setShowTitle,
        safeHeigth,
        objectModified,
        preview3D,
        curFabric,
        ossClient,
        setCurEvent,
        curEvent,
        titleChange,
        doOrder,
        addStep,
        onSubComplete,
        onDelCutpartObject,
        onEditText,
        notEmptyCodes,
        checkNotEmptyCodes,
        markAsChanged,
        hasUnsavedChanges,
        setHasUnsavedChanges,
        windowSize,
        responsiveLayout,
        textAc,
        preloadTrigger,
        setPreloadTrigger
    }


    return (
        <div style={{
            background: "linear-gradient(180deg, rgba(238,238,238,0) 0%, #F8F8F8 100%)",
            height: "100vh",
            overflow: "hidden"
        }}>
            {/* {!responsiveLayout.showSidebars && (
                <div style={{
                    position: 'fixed',
                    top: 100,
                    left: 10,
                    zIndex: 1000
                }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => setShowMobileSidebar(!showMobileSidebar)}
                    >
                        {showMobileSidebar ? t('隐藏') : t('菜单')}
                    </Button>
                </div>
            )} */}

            <div className="a" style={{
                display: (detailData?.model_materials?.map_info && detailData?.model_materials?.map_info?.length > 1) ? "block" : "none",
                position: windowSize.width < 768 ? 'fixed' : 'static',
                right: windowSize.width < 768 ? '10px' : '0px',
                top: windowSize.width < 768 ? "10vh" : "20vh",
                zIndex: 999
            }}>
                <Drag direction="y" style={{
                    right: windowSize.width < 768 ? '10px' : '0px',
                    top: windowSize.width < 768 ? "10vh" : "20vh",
                    zIndex: "999!important"
                }}>
                    <FixedNav
                        onChange={fixedNavOnChange}
                        visible={visibleFixedNav}
                        unActiveText={t('选择颜色')}
                        activeText={t('收起颜色')}
                        slotList={
                            <div
                                className="nut-fixednav__list"
                                slot="list"
                                style={{
                                    width: Math.min(detailData?.model_materials?.map_info?.length * 25 || 0, windowSize.width - 40),
                                    marginRight: 8,
                                    flexWrap: 'wrap',
                                    maxHeight: windowSize.width < 768 ? '200px' : 'none',
                                    overflowY: windowSize.width < 768 ? 'auto' : 'visible'
                                }}
                            >
                                {detailData?.model_materials?.map_info?.map((v: any) => (
                                    <div
                                        onClick={async () => {
                                            Toast.loading(t("加载中"), {
                                                cover: true,
                                                closeOnClickOverlay: false,
                                                duration: 0
                                            })
                                            if (detailData.model_materials.cutparts && detailData.model_materials.cutparts.length !== 0) {
                                                for (let i = 0; i < detailData.model_materials.cutparts.length; i++) {
                                                    let item = detailData.model_materials.cutparts[i]
                                                    action3D.clearMap(item.code)
                                                }
                                            }
                                            await choiceFabric(v, null, null)
                                            // Toast.hide()
                                        }}
                                        key={v.color}
                                        style={{
                                            width: 20,
                                            height: 20,
                                            background: v.color,
                                            margin: windowSize.width < 768 ? '5px' : '15px 5px',
                                            borderRadius: "50%",
                                            border: curFabric.color === v.color ? "solid 1px rgb(245, 119, 102)" : "solid 1px #fff",
                                            flexShrink: 0
                                        }}
                                    ></div>
                                ))}
                            </div>
                        }
                    />
                </Drag>
            </div>

            <Context.Provider value={contextValue}>
                <div style={previewMode ? {
                    position: "relative", zIndex: "2"
                } : {}}>
                    <Head action={headAc} />
                </div>
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: "flex",
                    flexDirection: responsiveLayout.displayFlexDirection,
                    position: 'relative'
                }}>
                    {(responsiveLayout.showSidebars || showMobileSidebar) && (
                        <div
                            data-component="menu"
                            style={!previewMode ? {
                                display: responsiveLayout.showSidebars ? 'block' : showMobileSidebar ? 'block' : 'none',
                                position: !responsiveLayout.showSidebars && showMobileSidebar ? 'absolute' : 'static',
                                left: 0,
                                top: 0,
                                bottom: 0,
                                zIndex: 999,
                                background: !responsiveLayout.showSidebars ? '#fff' : 'transparent',
                                boxShadow: !responsiveLayout.showSidebars ? '2px 0 5px rgba(0,0,0,0.1)' : 'none'
                            } : { position: "relative", zIndex: "2" }}
                        >
                            <Menu
                                action={menuRef}
                                activeMenu={activeMenu}
                                onClick={(key: MenuType) => {
                                    setActiveMenu(key);
                                    if (!responsiveLayout.showSidebars) {
                                        setShowMobileSidebar(false);
                                    }
                                }}
                            />
                        </div>
                    )}

                    {(responsiveLayout.showSidebars || showMobileSidebar) && (
                        <div
                            data-component="operation"
                            style={!previewMode ? {
                                width: responsiveLayout.operationWidth,
                                overflow: 'hidden',
                                height: responsiveLayout.showSidebars ? 'calc(100vh - 68px)' : 'calc(100% - 50px)',
                                display: responsiveLayout.showSidebars ? "flex" : showMobileSidebar ? "flex" : "none",
                                flexDirection: "column",
                                marginTop: responsiveLayout.showSidebars ? 12 : 0,
                                background: '#ffffff',
                                position: !responsiveLayout.showSidebars && showMobileSidebar ? 'absolute' : 'static',
                                left: responsiveLayout.showSidebars ? 'auto' : '80px',
                                top: 0,
                                bottom: 0,
                                zIndex: 998
                            } : { position: "relative" }}
                        >
                            {activeMenu === MenuType.YANSHE && (
                                <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                                    <Color
                                        action={colorAc}
                                        onPaneKeyChange={setTextPaneKey}
                                        preloadedData={preloadedData[MenuType.YANSHE as keyof typeof preloadedData]}
                                        dataLoading={loading[MenuType.YANSHE as keyof typeof loading]}
                                    />
                                </div>
                            )}

                            {activeMenu === MenuType.WENZI && (
                                <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                                    <Text
                                        action={textAc}
                                        onPaneKeyChange={setTextPaneKey}
                                        preloadedData={preloadedData[MenuType.WENZI]}
                                        dataLoading={loading[MenuType.WENZI]}
                                    />
                                </div>
                            )}

                            {activeMenu === MenuType.SUCAI && (
                                <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                                    <Pattern action={partternAc} preloadedData={preloadedData[MenuType.SUCAI]} dataLoading={loading[MenuType.SUCAI]} />
                                </div>
                            )}
                            {activeMenu === MenuType.LIEBIAO && (
                                <List />
                            )}

                        </div>
                    )}

                    <div
                        className="displayAnimate"
                        style={previewMode ? {
                            position: "fixed",
                            zIndex: 12,
                            background: "linear-gradient(180deg, rgba(238,238,238,1) 0%, #F8F8F8 100%)",
                            left: 0,
                            top: 0,
                            bottom: 0,
                            right: 0,
                            margin: "auto",
                            width: '100%',
                            height: '100%'
                        } : {
                            position: "relative",
                            flex: 1,
                            minWidth: responsiveLayout.showSidebars ? '300px' : '100%',
                            height: responsiveLayout.showSidebars ? '100%' : '50vh'
                        }}
                    >
                        <canvas
                            className="displayAnimate"
                            ref={canvasRef}
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'block',
                            }}
                        ></canvas>
                        {previewMode && (
                            <Button
                                onClick={quitPreview3D}
                                style={{
                                    position: "fixed",
                                    bottom: "5%",
                                    left: 0,
                                    right: 0,
                                    margin: "auto",
                                    width: Math.min(130, windowSize.width * 0.3),
                                    maxWidth: 130
                                }}
                                type="primary"
                            >
                                {t('退出预览')}
                            </Button>
                        )}
                    </div>
                    {/* 当前模块为图片和文字展示 */}
                    {/* {((responsiveLayout.showSidebars || showMobileSidebar)) && ( */}
                    <div
                        data-component="cutpart"
                        style={!previewMode ? {
                            opacity: (responsiveLayout.showSidebars || showMobileSidebar) &&
                                (activeMenuRef.current === MenuType.SUCAI || activeMenuRef.current === MenuType.WENZI) ? 1 : 0,
                            pointerEvents: (responsiveLayout.showSidebars || showMobileSidebar) &&
                                (activeMenuRef.current === MenuType.SUCAI ||
                                    activeMenuRef.current === MenuType.WENZI) ? 'auto' : 'none',
                            width: responsiveLayout.cutpartWidth,
                            background: '#ffffff',
                            padding: '0 10px',
                            height: responsiveLayout.showSidebars ? '100%' : 'calc(100% - 50px)',
                            overflow: 'auto',
                            position: !responsiveLayout.showSidebars && showMobileSidebar ? 'absolute' : 'static',
                            right: 0,
                            top: 0,
                            bottom: 0,
                            zIndex: 998,
                        } : { position: "relative" }}
                    >
                        <div style={{ marginTop: 10 }}>
                            <Info action={infoAc} />
                        </div>
                        <Cutpart action={cutpartAc} />
                        <ActionTitle action={actionTitleAc} />
                        {/* <Graffiti action={graffitiAc} activeMenu={activeMenu} /> */}
                        {/* <HistoryPanel
                                headAc={headAc}
                                fabricClient={fabricClient}
                            /> */}

                    </div>
                    {/* )} */}

                </div>

                <Plugins>
                    <Loading progress={progress} />
                    <div ref={safeHeightRef} style={{
                        height: "env(safe-area-inset-bottom)",
                        position: "fixed",
                        zIndex: -1,
                        bottom: 0,
                        left: 0
                    }}></div>
                </Plugins>
            </Context.Provider >
        </div >
    )
}

export default Index
